import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Box,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { SectionTitle, SectionSubtitle1 } from './SectionTypography'

interface StepZeroProps {
  control: any
  watchedForm: any
}

const StepZero = ({ control, watchedForm }: StepZeroProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Controller
        name="injured"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            component="fieldset"
            sx={{ width: '100%', mb: 3 }}
            error={!!error}
          >
            <SectionSubtitle1 sx={{ fontWeight: 600, color: 'text.primary' }}>
              {t('damage_during_route.injured_question')}
            </SectionSubtitle1>
            <RadioGroup
              value={
                field.value === null
                  ? ''
                  : field.value === true
                    ? 'true'
                    : 'false'
              }
              onChange={(e) => field.onChange(e.target.value === 'true')}
            >
              <FormControlLabel
                value="true"
                control={<Radio />}
                label={t('common.yes')}
              />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label={t('common.no')}
              />
            </RadioGroup>
            {error && (
              <Typography color="error" variant="caption">
                {error.message ? t(error.message) : 'Error'}
              </Typography>
            )}
          </FormControl>
        )}
      />

      {watchedForm.injured === true && (
        <Box sx={{ mt: 2, bgcolor: '#fff3f3', p: 2, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <WarningAmberOutlinedIcon
              sx={{ fontSize: 32, mr: 1.5, color: 'error.main' }}
            />
            <SectionTitle sx={{ color: 'error.main', mb: 0 }}>
              {t('damage_during_route.call_emergency')}
            </SectionTitle>
          </Box>
          <Box component="ul" sx={{ pl: 4, mb: 0, fontSize: '1rem' }}>
            <li>{t('damage_during_route.emergency_instruction_1')}</li>
            <li>{t('damage_during_route.emergency_instruction_2')}</li>
            <li>{t('damage_during_route.emergency_instruction_3')}</li>
            <li>{t('damage_during_route.emergency_instruction_4')}</li>
          </Box>
        </Box>
      )}

      {watchedForm.injured === false && (
        <Box
          sx={{
            mt: 2,
            bgcolor: '#f3f7ff',
            p: 2,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <InfoOutlinedIcon
              sx={{ fontSize: 32, mr: 1.5, color: 'primary.main' }}
            />
            <SectionTitle sx={{ color: 'primary.main', mb: 0 }}>
              {t('damage_during_route.safety_title')}
            </SectionTitle>
          </Box>
          <Box component="ul" sx={{ pl: 4, mb: 0, fontSize: '1rem' }}>
            <li>{t('damage_during_route.safety_instruction_1')}</li>
            <li>{t('damage_during_route.safety_instruction_2')}</li>
            <li>{t('damage_during_route.safety_instruction_3')}</li>
            <li>{t('damage_during_route.safety_instruction_4')}</li>
          </Box>
        </Box>
      )}
    </>
  )
}

export default StepZero
